import React, { memo, useMemo } from 'react';

// helpers
import { StepStatus } from '..';
import { colorsTheme } from 'resources/theme/styled/colors';

// components
import { IconSVG, IconSVGProps } from '@ui';
import { ReactComponent as CheckIcon } from 'resources/icons/remix-icons/checkbox-circle-fill.svg';
import { ReactComponent as CircleIcon } from 'resources/icons/remix-icons/circle-line.svg';
import { ReactComponent as ContrastIcon } from 'resources/icons/remix-icons/contrast-fill.svg';
import { ReactComponent as WithdrawIcon } from 'resources/icons/remix-icons/arrow-left-circle-fill.svg';
import { ReactComponent as TimeIcon } from 'resources/icons/remix-icons/time-line.svg';
import { ReactComponent as CloseIcon } from 'resources/icons/remix-icons/close-circle-fill.svg';
import { ReactComponent as AlertIcon } from 'resources/icons/remix-icons/alert-fill.svg';

interface IProps {
  status: StepStatus;
}

const StatusIcon = memo(({ status }: IProps) => {
  const iconProps = useMemo<IconSVGProps>(() => {
    switch (status) {
      case 'new':
        return { component: CircleIcon };

      case 'completed':
        return { component: CheckIcon, color: colorsTheme.colorPrimary };

      case 'in-progress':
        return { component: ContrastIcon, color: colorsTheme.colorPrimary };

      case 'archived':
      case 'withdrawn':
        return { component: WithdrawIcon, color: colorsTheme.colorWarning };

      case 'under-review':
        return { component: TimeIcon, color: colorsTheme.colorWhite };

      case 'declined':
        return { component: CloseIcon, color: colorsTheme.colorError };

      case 'invalid':
        return { component: AlertIcon, color: colorsTheme.colorWarning };
    }
  }, [status]);

  return <IconSVG {...iconProps} />;
});

export default StatusIcon;
